import EHOIcon from './EHOIcon'
import React, { FC } from 'react'
import { FEATURE_FLAG_TYPES } from '@mortgage-pos/data'
import { environment } from '@mortgage-pos/ui/env'
import { footerContent } from '@mortgage-pos/ui/data/footerContent'
import { useVariation } from '@mortgage-pos/ui/services/featureFlags'
import { BankrateSocialFooter } from '@mortgage-pos/ui/components/bankrateCompare/BankrateSocialFooter'
import { useNavigate } from 'react-router-dom'
import { Routes } from '@mortgage-pos/types'

export type Props = {
  className?: string
}

export const Footer: FC<Props> = ({ className }) => {
  const navigate = useNavigate()

  const bankrateCompareEnabled = useVariation(
    FEATURE_FLAG_TYPES.BANKRATE_COMPARE_ENABLED
  )

  return (
    <footer className={className ? `footer ${className}` : `footer`}>
      {bankrateCompareEnabled ? <BankrateSocialFooter /> : null}

      <div className="footer__compliance-container">
        <EHOIcon className="footer__equal-housing-icon" />
        {footerContent[environment.productName]?.title ??
          footerContent.sage.title}
        {environment.productName === 'sage-home-loans' ? (
          <a className="footer__link" href="https://nmlsconsumeraccess.org/">
            nmlsconsumeraccess.org
          </a>
        ) : null}
        <br />
        {footerContent[environment.productName]?.copyright ??
          footerContent.sage.copyright}
        {environment.productName === 'sage' ? (
          <a className="footer__link" href="https://nmlsconsumeraccess.org/">
            nmlsconsumeraccess.org
          </a>
        ) : null}
        <br />
        <br />
        {footerContent[environment.productName]?.additionalContent && (
          <>
            <p>{footerContent[environment.productName].additionalContent}</p>
            <br />
          </>
        )}
        <button
          className="ot-sdk-show-settings main-footer__info-block-link"
          tabIndex={0}
        >
          Cookie Settings
        </button>
        <span> | </span>
        <button
          className="main-footer__info-block-link"
          onClick={() => navigate(`/${Routes.APP_1003}/onetrust-dns-agreement`)}
        >
          Do not sell my info
        </button>
      </div>
    </footer>
  )
}

export default Footer
